import React from 'react';

function I({ children, className = '', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={"shrink-0 " + className}
      {...props}
    >
      {children}
    </svg>
  );
}

export const ArrowRight = (p) => (
  <I {...p}>
    <path d="M5 12h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </I>
);

export const Menu = (p) => (
  <I {...p}>
    <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const X = (p) => (
  <I {...p}>
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Leaf = (p) => (
  <I {...p}>
    <path d="M20 4c-7 1-12 6-13 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M4 20c7-1 12-6 13-13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 17c2-3 5-6 10-10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Info = (p) => (
  <I {...p}>
    <path d="M12 17v-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 8h.01" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" stroke="currentColor" strokeWidth="2"/>
  </I>
);

export const Mail = (p) => (
  <I {...p}>
    <path d="M4 6h16v12H4V6Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const SolarPanel = (p) => (
  <I {...p}>
    <path d="M4 10h16l-1 8H5l-1-8Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8 10l1 8M16 10l-1 8M12 10v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M10 22h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 18v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M7 6h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Sun = (p) => (
  <I {...p}>
    <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M19 19l-1.5-1.5M19 5l-1.5 1.5M5 19l1.5-1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const ShieldCheck = (p) => (
  <I {...p}>
    <path d="M12 2 20 6v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8 12l2.5 2.5L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </I>
);

export const BarChart3 = (p) => (
  <I {...p}>
    <path d="M4 20V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M10 20V4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 20v-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 20H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Wrench = (p) => (
  <I {...p}>
    <path d="M21 7a5 5 0 0 1-7 4L7 18l-3 3-2-2 3-3 7-7A5 5 0 0 1 17 3l-3 3 4 4 3-3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const MapPinned = (p) => (
  <I {...p}>
    <path d="M12 22s7-4.5 7-12a7 7 0 1 0-14 0c0 7.5 7 12 7 12Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" stroke="currentColor" strokeWidth="2"/>
  </I>
);

export const Sparkles = (p) => (
  <I {...p}>
    <path d="M12 2l1.2 3.6L17 7l-3.8 1.4L12 12l-1.2-3.6L7 7l3.8-1.4L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M19 12l.8 2.4L22 15l-2.2.6L19 18l-.8-2.4L16 15l2.2-.6L19 12Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const BadgeCheck = (p) => (
  <I {...p}>
    <path d="M12 2l2 2 3-1 1 3 3 1-1 3 2 2-2 2 1 3-3 1-1 3-3-1-2 2-2-2-3 1-1-3-3-1 1-3-2-2 2-2-1-3 3-1 1-3 3 1 2-2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M8.5 12l2 2 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </I>
);

export const Globe2 = (p) => (
  <I {...p}>
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M2 12h20" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 2c3 3 3 17 0 20-3-3-3-17 0-20Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const Target = (p) => (
  <I {...p}>
    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 12h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Calendar = (p) => (
  <I {...p}>
    <path d="M6 4v2M18 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M4 8h16" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 6h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="2"/>
  </I>
);

export const Factory = (p) => (
  <I {...p}>
    <path d="M3 20V10l6 3V10l6 3V10l6 3v7H3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M3 20h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const MapPin = (p) => (
  <I {...p}>
    <path d="M12 22s7-4.5 7-12a7 7 0 1 0-14 0c0 7.5 7 12 7 12Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M12 11.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" stroke="currentColor" strokeWidth="2"/>
  </I>
);

export const Maximize2 = (p) => (
  <I {...p}>
    <path d="M15 3h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 3l-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M9 21H3v-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M3 21l7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Zap = (p) => (
  <I {...p}>
    <path d="M13 2 3 14h8l-1 8 10-12h-8l1-8Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const Copy = (p) => (
  <I {...p}>
    <path d="M9 9h10v10H9V9Z" stroke="currentColor" strokeWidth="2"/>
    <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </I>
);

export const Phone = (p) => (
  <I {...p}>
    <path d="M6 3h3l2 5-2 1c1.5 3 3.5 5 6.5 6.5l1-2 5 2v3c0 1-1 2-2 2-10 0-18-8-18-18 0-1 1-2 2-2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);

export const Send = (p) => (
  <I {...p}>
    <path d="M22 2 11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M22 2 15 22l-4-9-9-4 20-7Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </I>
);
